module.exports = __webpack_public_path__ + "img/icon_nav_map.58224441.svg";